import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Organization } from './ModuleFE_Organization.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS, QuaiManager_DropDownCaret } from '@app/styles';
import { countryOptions } from '../../ui/Page_OrganizationEditor/consts.js';
const Props_DropDown = {
    module: ModuleFE_Organization,
    modules: [ModuleFE_Organization],
    mapper: item => [item.name],
    placeholder: 'Choose a Organization',
    renderer: item => _jsx(_Fragment, { children: item.name })
};
export const DropDown_Organization = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Organization,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.name] });
    },
    uiSelector: DropDown_Organization.selectable,
});
export const MultiSelect_Organization = TS_MultiSelect_V2.prepare(Props_MultiSelect);
export const DropDown_OrgCountry = TS_DropDown.prepare({
    adapter: SimpleListAdapter(countryOptions.map(item => item.country), op => _jsx(_Fragment, { children: op.item })),
    caret: QuaiManager_DropDownCaret,
});
//# sourceMappingURL=ui-components.js.map